import { produce } from 'immer';

import { HALCYON_FORM_CATALOG_ACTION_TYPE } from '../actions';

const initialState = {
  items: [],
};

const halcyonFormCatalogReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case HALCYON_FORM_CATALOG_ACTION_TYPE.GET_HALCYON_FORM_CATALOG:
        draft.items = payload || [];
        break;

      default:
        return state;
    }
  });

export default halcyonFormCatalogReducer;
